import React, { useEffect, useState } from "react";

/**
 * Preloader — the brand logo with a loading bar below it.
 * Fades out cleanly when `exiting` becomes true.
 *
 * Props:
 *  exiting   – when true, plays the fade-out
 *  onExited  – called once the fade-out completes
 */
export default function LoadingScreen({ exiting = false, onExited }) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!exiting) return;
    // Match the fade-out duration (0.5s).
    const t = setTimeout(() => {
      setDone(true);
      onExited && onExited();
    }, 520);
    return () => clearTimeout(t);
  }, [exiting, onExited]);

  if (done) return null;

  return (
    <div className={`pl-root${exiting ? " is-exiting" : ""}`} aria-label="Loading" role="status">
      <div className="pl-stage">
        <img
          src="/assets/preloader-logo.png"
          alt="DRIVN FREIGHT"
          className="pl-logo"
          draggable={false}
        />
        <div className="pl-bar" />
      </div>
    </div>
  );
}
